import styled from "@emotion/styled";

type AlignOptions =
    | "normal"
    | "stretch"
    | "center"
    | "start"
    | "end"
    | "flex-start"
    | "flex-end"
    | "self-start"
    | "self-end"
    | "baseline"
    | "first baseline"
    | "last baseline"
    | "safe center"
    | "unsafe center";

type JustifyContentOptions =
    | "center"
    | "start"
    | "end"
    | "flex-start"
    | "flex-end"
    | "left"
    | "right"
    | "space-between"
    | "space-around"
    | "space-evenly"
    | "stretch"
    | "safe center"
    | "unsafe center";

type FlexWrapOptions = "nowrap" | "wrap" | "wrap-reverse";
type FlexDirectionOptions = "row" | "row-reverse" | "column" | "column-reverse";

export interface FlexboxProps {
    flex?: string;
    flexShrink?: number;
    flexWrap?: FlexWrapOptions;
    flexDirection?: FlexDirectionOptions;
    alignItems?: AlignOptions;
    justifyContent?: JustifyContentOptions;
    flexBasis?: string;
    gap?: string;
    width?: string;
    height?: string;
}

export const Flexbox = styled.div`
    display: flex;
    flex: ${({ flex }: FlexboxProps) => flex};
    flex-basis: ${({ flexBasis }: FlexboxProps) => flexBasis};
    flex-direction: ${({ flexDirection }: FlexboxProps) => flexDirection};
    flex-shrink: ${({ flexShrink }: FlexboxProps) => flexShrink};
    /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */
    flex-wrap: ${({ flexWrap }: FlexboxProps) => flexWrap};
    gap: ${({ gap }) => gap};
    align-items: ${({ alignItems }: FlexboxProps) => alignItems};
    justify-content: ${({ justifyContent }: FlexboxProps) => justifyContent};

    width: ${({ width }: FlexboxProps) => width};
    height: ${({ height }: FlexboxProps) => height};
`;
